// Notification sound
export function playNotificationSound() {
  try {
    const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBiJ+zPLVgzoIHGS57OecWA8OVqvl7bNiHRZFnePxwmgjBSKAzvLVgjoIHGG56+ejWBIJVqzm77RjGxI8neDyw3IqBiJ+zPLVgjoIH2K56+ejWBIJVqzm77RjGxI8neDyw3IqBiJ+zPLVgjoIH2K56+ejWBIJVqzm77RjGxI8neDyw3IqBiJ+zPLVgjoIH2K56+ejWBIJVqzm77RjGxI=')
    audio.volume = 0.3
    audio.play().catch(e => console.log('Sound play failed:', e))
  } catch (e) {
    console.log('Sound not supported')
  }
}

export function showNotificationPopup(message, onViewResults) {
  const popup = document.createElement('div')
  popup.className = 'notification-popup'
  popup.innerHTML = `
    <div class="notification-content">
      <div class="notification-icon">🎉</div>
      <h3 class="notification-title">${message}</h3>
      <p class="notification-text">Resultatet er klar til at blive set.</p>
      <button class="notification-btn" id="viewResultsBtn">
        Se resultatet nu →
      </button>
      <button class="notification-close" id="closeNotificationBtn">×</button>
    </div>
  `
  
  document.body.appendChild(popup)
  
  document.getElementById('viewResultsBtn').onclick = () => {
    document.body.removeChild(popup)
    onViewResults()
  }
  
  document.getElementById('closeNotificationBtn').onclick = () => {
    document.body.removeChild(popup)
  }
  
  setTimeout(() => {
    if (document.body.contains(popup)) {
      document.body.removeChild(popup)
    }
  }, 30000)
}
